import { Link } from 'react-router'
import {
  achievements,
  industries,
  productCategories,
  services,
} from '~/data/siteData'
import { EventsSection } from '~/components/EventsSection'
import {
  AchievementsSection,
  ClientsStrip,
  ContactCtaSection,
  EnquirySection,
  HeroSection,
  IndustriesSection,
  SectionTitle,
  ReviewsSection,
  ServicesSection,
} from '~/components/Sections'

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <ClientsStrip />

      {/* What We Offer — all product categories */}
      <section className="section-pad">
        <div className="container">
          <SectionTitle
            eyebrow="What We Offer"
            title="Machines, inks, and complete support"
            description="From digital printers to CNC routers and laminators — everything you need to run a profitable print business."
          />
          <div className="product-cat-grid">
            {productCategories.map((cat) => (
              <div className="product-cat-card" key={cat.name}>
                <img className="product-cat-img" src={cat.img} alt={cat.name} loading="lazy" />
                <h3>{cat.name}</h3>
                <p>{cat.desc}</p>
              </div>
            ))}
          </div>
          <div className="section-view-all">
            <Link className="btn btn-ghost-light" to="/products">View all products →</Link>
          </div>
        </div>
      </section>

      <ServicesSection items={services} />
      <IndustriesSection items={industries} preview />
      <AchievementsSection items={achievements} />
      <EventsSection preview />
      <ReviewsSection preview />
      <EnquirySection />
      <ContactCtaSection />
    </main>
  )
}
